import React from "react";

const error401= (props) => {
    return (
        <h5>
            401 - Acces to {props.location} denied.
        </h5>
    );
};

export default error401;


// WEBPACK FOOTER //
// ./src/components/Route/error401.js